//called from Login.js
import React, { useEffect } from "react";
import { useState } from "react";
import { Button, Typography, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Status from "../components/Status";
import { useNavigate } from "react-router-dom";
import { ArrowBack, CheckCircleOutline } from "@material-ui/icons";
import Loader from "../Loader";
import TextfieldStyled from "../components/TextfieldStyled/TextfieldStyled";
import styles from "./loginHelp.module.css";
import { useAuth } from "../utils/AuthProvider";


//its a Material-UI hook for defining custom styles for components
const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(2),
  },
}));

//its the main component function that holds the entire login assistance form
function LoginHelp() {
  const {token}=useAuth()

  const classes = useStyles();
  const navigate=useNavigate();

  const [actionstatus, setactionstatus] = useState("invisible");
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState();

  const [enterOTP, setEnterOTP] = useState(false);
  const [OTPmatched, setOTPmatched] = useState(false);
  const [success, setsuccess] = useState(false);

  const [userName, setUserName] = useState(); //initial value undefined
  const [otpValue, setOtpValue] = useState();
  const [credentialId, setCredentialId] = useState();
  const [userProfile, setUserProfile] = useState();
  const [emailVerified, setEmailVerified] = useState(false);
  const [jwtToken, setJwtToken] = useState();
  const [otpVerification, setOtpVerification] = useState();
  // console.log("username:",userName)
  const [errorMessage, setErrorMessage] = useState("");


  const checkUserName = () => {
    // console.log("userName", userName);
    if (!userName || userName.trim() === "") {
    setErrorMessage("no username");
    return;
  }
  setErrorMessage("");
    if (userName !== undefined) {
      const requestOptions = {
        method: "GET",
        headers: { "content-type": "application/json" },
      };
      setloading(true);
      setCredentialId();
      fetch(
        `${process.env.REACT_APP_ENDPOINT}/credentials/userexists/${userName}`,
        requestOptions
      )
        .then((response) => {
          if (!response.ok) {
            setloading(false);
            console.log("Error:", response);
            setErrorMessage("not found");
          } else {
            return response.json();
          }
        })
        .then((data) => {
          console.log("Data:", data);
          if (data !== undefined) {
            //setloading(false);
            setCredentialId(data?.id);
            setErrorMessage("");
          }
        })
        .catch((error) => {
          console.log("error in getting data");
        });
    }
  };
  //console.log("credentialId:",credentialId)
  useEffect(() => {
    if (credentialId !== undefined) {
      // console.log("credentialId",credentialId)
      const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, },
      };
      setErrorMessage("");
      fetch(
        `${process.env.REACT_APP_ENDPOINT}/prof?credentialid=${credentialId}`,
        requestOptions
      )
        .then((response) => {
          if (!response.ok) {
            console.log("Error in getting error");
          }
          return response.json();
        })
        .then((data) => {
          //data conatins array of objects
          // console.log("main data:",data)
          if (data && data?.data) {
            // console.log("data:",data?.data)
            setUserProfile(data?.data[0]);
          } else {
            //console.log("pp:",data)
            setErrorMessage("no profile found");
            setloading(false);
          }
        })
        .catch((error) => {
          console.log("error in getting data");
        });
    }
  }, [credentialId]);
  // console.log("userprofile",userProfile  && userProfile)
  useEffect(() => {
    // console.log("A...")
    if (userProfile !== undefined && userProfile) {
      // console.log("B...")
      if (userProfile?.email) {
        // console.log("C..")
        //console.log("checking email", userProfile.email);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmailValid = emailRegex.test(userProfile.email);
        if (isEmailValid) {
          console.log("Email is in a valid format:", userProfile.email);
          setEmailVerified(true);
        } else {
          console.log("Email is not in a valid format:", userProfile.email);
          setEmailVerified(false);
          setErrorMessage("email not valid");
          setloading(false);
        }
      }
    } else {
      // setErrorMessage("no profile found");
    }
    //setErrorMessage("")
  }, [userProfile]);

  useEffect(() => {
    if (emailVerified) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: credentialId,
          action: "Reset Password",
        }),
      };
      fetch(`${process.env.REACT_APP_ENDPOINT}/otp`, requestOptions)
        .then((response) => {
          if (!response.ok) {
            console.log("Error in getting error");
          }
          return response.json();
        })
        .then((data) => {
          setUserName("");
          setloading(false);
          setEnterOTP(true);
          setJwtToken(data);
          setEmailVerified(false);
        })
        .catch((error) => {
          console.log("error in getting data");
        });
    }
  }, [emailVerified]);
  //console.log("jwt token",jwtToken?.token)

  const verifyOTP = () => {
    // console.log("otp:", otpValue);
    //console.log("jwt token:::", jwtToken);
    setErrorMessage("");
    if (jwtToken !== undefined && otpValue !== undefined) {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken.token}`,
        },
      };
      setloading(true);
      fetch(
        `${process.env.REACT_APP_ENDPOINT}/otp/verify/${otpValue}`,
        requestOptions
      )
        .then((response) => {
          if (!response.ok) {
            console.log("Error in getting error");
            setErrorMessage("wrong otp");
            setloading(false);
          }
          //console.log("verifyOTP response:", response);
          return response.text();
        })
        .then((data) => {
          //console.log("verifyOTP", data);
          setOtpVerification(data);
        })
        .catch((error) => {
          console.log("error in getting data");
        });
    }
  };
  //console.log("verifyOTP Message:",otpVerification)
  useEffect(() => {
    if (otpVerification !== undefined) {
      if (otpVerification === "Otp verified") {
        setOTPmatched(true);
        setloading(false);
        setUserName("");
      }
    }
  }, [otpVerification]);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [checkStatus, setCheckStatus] = useState("");
  useEffect(() => {
    if (password !== "" && confirmPassword !== "") {
      if (confirmPassword === password) {
        setCheckStatus("same");
      } else {
        setCheckStatus("not same");
      }
    } else {
      setCheckStatus("");
    }
  }, [confirmPassword, password]);

  useEffect(() => {
    if (password.length > 0 && password.length < 8) {
      //console.log("password should be of 8 characters")
      setErrorMessage("password small");
    } else {
      setErrorMessage("");
    }
  }, [password]);

  const saveNewPassword = () => {
    if (!password || password.trim() === "") {
      setErrorMessage("password required");
      return;
    }
    if (password.length < 8) {
      setErrorMessage("password small");
      return;
    }
    if (!confirmPassword || password !== confirmPassword) {
      setCheckStatus("not same");
      return;
    }
    if (OTPmatched && jwtToken !== undefined) {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken.token}`,
        },
        body: JSON.stringify({
          newpassword: password,
        }),
      };
      setloading(true);
      fetch(
        `${process.env.REACT_APP_ENDPOINT}/credentials/resetpassword`,
        requestOptions
      )
        .then((response) => {
          if (!response.ok) {
            console.log("Error in getting error");
            setloading(false);
          }
          return response.json();
        })
        .then((data) => {
          //console.log("final response: ", data);
          if (data.resp === "Password reset successful") {
            setsuccess(true);
            setloading(false);
          } else {
            setloading(false);
          }
        })
        .catch((error) => {
          console.log("error in getting data");
          setloading(false);
        });
    }
  };

  const hideEmail=(email)=>{
    const[name,domain]=email.split("@");
    if(name.length<=2) return email; // when email is small
    const firstPart=name.slice(0,3)
    const secondPart=name.slice(-2);
    //takes first 3 letters of the email and last 2 characters of email before @ and puts ***** in between them

    return `${firstPart}***${secondPart}@${domain}`;
  };

  const handleBack = () => {
    if (success) {
      setsuccess(false);
      setOTPmatched(false);
      setEnterOTP(false);
      navigate("/login");
    } else if (OTPmatched) {
       // Reset Password screen -> go back to OTP verification screen
      setOTPmatched(false);
      setOtpVerification(undefined);
      setErrorMessage("");
      setPassword("");
      setConfirmPassword("");
      setCheckStatus("");
    } else if (enterOTP) {
       // OTP verification screen -> go back to Enter Username screen
      setEnterOTP(false);
      setErrorMessage("");
      setOtpValue("");
    } else {
         // Username screen -> return to login
      navigate("/login");
    }
  };

  return (
    <div className={styles.reset_container}>
      {/*container for the forgot password flow*/}
      <div className={styles.formContainer}>
        <Status
          actionstatus={actionstatus}
          setactionstatus={setactionstatus}
          message={message}
        />

        <div className={styles.heading}>
          <IconButton aria-label="back" onClick={handleBack}>
            <ArrowBack />
          </IconButton>
          <Typography
            style={{ fontWeight: "400", color: "#6153BD" }}
            variant="h6"
          >
            Forgot Password
          </Typography>
        </div>
        {enterOTP ? ( //by default its false it will be true when user enters email/userid/phone
          //will be shown when users enters OTP
          <div className={styles.forgetPasswordFields}>
            {OTPmatched ? ( //its false by default it will be true when user enters OTP and it matchs
              <>
                {/*will be shown when OTP is matched and API call is made successfully */}
                {success ? ( //by default its false
                  //this component will be called when users enters new password
                  <PasswordSuccess
                    classes={classes}
                  />
                ) : (
                  //This will be shown for user to enter new password
                  <div className={styles.reset_password_container}>
                    <div>
                      <TextfieldStyled
                        placeholder="Please Enter The New Password"
                        type="password"
                        width="100%"
                        color="white"
                        label=""
                        onChangehandler={(e) => setPassword(e.target.value)}
                        name="password"
                        value={password}
                        error={
                          errorMessage === "password small" ||
                          errorMessage === "password required"
                        }
                        helpertext={
                          errorMessage === "password required"
                            ? "Password required"
                            : errorMessage === "password small"
                            ? "Password must be atleast of 8 characters"
                            : ""
                        }
                      />
                    </div>
                    <div>
                      <TextfieldStyled
                        placeholder="Please Re-Enter The Password"
                        type="password"
                        width="100%"
                        color="white"
                        label=""
                        onChangehandler={(e) =>
                          setConfirmPassword(e.target.value)
                        }
                        name="confirmPassword"
                        value={confirmPassword}
                        error={checkStatus === "not same"}
                        helpertext={
                          checkStatus === "not same" && "Passwords do not match"
                        }
                      />
                    </div>
                    <div>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        className={classes.button}
                        style={{
                          textTransform: "none",
                          boxSizing: "border-box",
                          color: "#6153BD",
                          borderColor: "#6153BD",
                          fontWeight: "300",
                        }}
                        onClick={saveNewPassword}
                      >
                        {!loading ? (
                          "RESET PASSWORD"
                        ) : (
                          <>
                            RESET PASSWORD
                            <div className={styles.loader}>
                              <Loader color="#6153BD" />
                            </div>
                          </>
                        )}
                      </Button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                {enterOTP && (
                  <div className={styles.text}>
                    <p style={{ fontWeight: "500", color: "#2E7D32" }}>
                      OTP sent to the registered email-address
                    </p>
                    {/* {userProfile && userProfile?.email && <p style={{ fontWeight: "300",fontSize:"0.9rem"}}>{hideEmail(userProfile?.email)}</p>} */}
                    {userProfile && userProfile?.email && <p style={{ fontWeight: "300",fontSize:"0.9rem"}}>{userProfile?.email}</p>}
                  </div>
                )}
                {/*this will shown to user for entering OTP code received via email/phone */}
                <div>
                  <TextfieldStyled
                    placeholder="Please Enter The 6-Digit Code"
                    name="otpValue"
                    width="100%"
                    color="white"
                    label=""
                    onChangehandler={(e) => setOtpValue(e.target.value)}
                    value={otpValue}
                    error={errorMessage === "wrong otp"}
                    helpertext={
                      errorMessage === "wrong otp"
                        ? "Entered OTP Is Wrong/Used"
                        : ""
                    }
                  />
                </div>
                <div>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="primary"
                    className={classes.button}
                    style={{
                      textTransform: "none",
                      boxSizing: "border-box",
                      color: "#6153BD",
                      borderColor: "#6153BD",
                      fontWeight: "300",
                    }}
                    onClick={verifyOTP}
                  >
                    {!loading ? (
                      "SUBMIT CODE"
                    ) : (
                      <>
                        SUBMIT CODE
                        <div
                          className={styles.loader}
                        >
                          <Loader color="#6153BD" />
                        </div>
                      </>
                    )}
                  </Button>
                </div>
              </>
            )}
          </div>
        ) : (
          //this will be shown to user for entering email/phone/username on whihc they will receive OTP
          <div className={styles.forgetPasswordFields}>
            <div>
              <TextfieldStyled
                placeholder="Please enter your username"
                name="userName"
                width="100%"
                color="white"
                label=""
                onChangehandler={(e) => setUserName(e.target.value)}
                value={userName}
                error={
                  errorMessage === "not found" ||
                  errorMessage === "email not valid" ||
                  errorMessage === "no profile found" ||
                  errorMessage === "no username"
                }
                helpertext={
                  errorMessage === "not found"
                    ? "User does not exist"
                    : errorMessage === "email not valid"
                    ? "Linked Email Is Invalid/Didn't Exist"
                    : errorMessage === "no profile found"
                    ? "Profile Not Created Yet"
                    : errorMessage==="no username"
                    ?"Please enter username"
                    : ""
                }
              />
            </div>
            <div>
              <Button
                // disabled={!userName}
                fullWidth
                variant="outlined"
                color="primary"
                className={classes.button}
                onClick={checkUserName}
                style={{
                  textTransform: "none",
                  boxSizing: "border-box",
                  color: "#6153BD",
                  borderColor: "#6153BD",
                  fontWeight: "300",
                }}
              >
                {!loading ? (
                  "Send Reset Code"
                ) : (
                  <>
                    Sending code
                    <div className={styles.loader}>
                      <Loader color="#6153BD" />
                    </div>
                  </>
                )}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function PasswordSuccess({ classes }) {
  const navigate=useNavigate()
  return (
    <div className={styles.back_to_login}>
      <div className={styles.container}>
        <CheckCircleOutline style={{ color: "#2E7D32" }} fontSize="large" />
        <div className={styles.text}>
          <p style={{ fontWeight: "500" }}>Password Reset Successfully</p>
          <p>Please go to the login page to sign in</p>
        </div>
      </div>
      <div>
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          className={classes.button}
          style={{
            textTransform: "none",
            boxSizing: "border-box",
            color: "#6153BD",
            borderColor: "#6153BD",
            fontWeight: "300",
          }}
          onClick={() => {
            navigate("/login")
          }}
        >
          GO TO LOGIN PAGE
        </Button>
      </div>
    </div>
  );
}

export default LoginHelp;
